/**
 * Green Growth Digital - Main Scripts
 */
(function () {
  'use strict';

  // ─── FAQ Accordion ───
  document.querySelectorAll('.faq-item').forEach(function (item) {
    var question = item.querySelector('.faq-question');
    if (question) {
      question.addEventListener('click', function () {
        var wasActive = item.classList.contains('active');
        document.querySelectorAll('.faq-item').forEach(function (i) {
          i.classList.remove('active');
        });
        if (!wasActive) {
          item.classList.add('active');
        }
      });
    }
  });

  // ─── Mobile Menu ───
  var navToggle = document.querySelector('.nav-toggle');
  var mobileMenu = document.getElementById('mobileMenu');
  var mobileClose = document.querySelector('.mobile-menu-close');

  if (navToggle && mobileMenu) {
    navToggle.addEventListener('click', function () {
      mobileMenu.classList.add('active');
      document.body.style.overflow = 'hidden';
    });

    if (mobileClose) {
      mobileClose.addEventListener('click', function () {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    // Close mobile menu when clicking a link
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileMenu.classList.remove('active');
        document.body.style.overflow = '';
      });
    });
  }

  // ─── Mobile Dropdown Toggle ───
  document.querySelectorAll('.mobile-dropdown-toggle').forEach(function (toggle) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      var items = this.nextElementSibling;
      if (items) {
        items.classList.toggle('active');
        var arrow = this.querySelector('.dropdown-arrow') || this.querySelector('.dropdown-arrow-text');
        if (arrow) {
          arrow.style.transform = items.classList.contains('active') ? 'rotate(180deg)' : '';
        }
      }
    });
  });

  // ─── Scroll Animations ───
  var animatedElements = document.querySelectorAll(
    '.service-card, .process-step, .why-card, .result-card, .pricing-card, .testimonial-card, .faq-item'
  );

  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.style.opacity = '1';
            entry.target.style.transform = 'translateY(0)';
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    animatedElements.forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(24px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
      observer.observe(el);
    });
  }

  // ─── Smooth Scroll for Anchor Links ───
  document.querySelectorAll('a[href^="#"]').forEach(function (link) {
    link.addEventListener('click', function (e) {
      var href = this.getAttribute('href');
      if (href && href.length > 1) {
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          var offset = 80; // account for sticky nav
          var top = target.getBoundingClientRect().top + window.pageYOffset - offset;
          window.scrollTo({ top: top, behavior: 'smooth' });
        }
      }
    });
  });

  // ─── Sticky Nav Shadow on Scroll ───
  var nav = document.querySelector('.site-nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      if (window.scrollY > 10) {
        nav.style.boxShadow = '0 2px 20px rgba(0,0,0,0.06)';
      } else {
        nav.style.boxShadow = 'none';
      }
    });
  }
})();

/* ═══════════════════════════════════════════
   STICKY NAV — Scroll detection
   Add to bottom of main.js (or paste into a new asset)
   ═══════════════════════════════════════════ */

(function () {
  const header = document.getElementById('shopify-section-header');
  if (!header) return;

  let ticking = false;

  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(function () {
        if (window.scrollY > 10) {
          header.classList.add('scrolled');
        } else {
          header.classList.remove('scrolled');
        }
        ticking = false;
      });
      ticking = true;
    }
  });
})();

// Contact Services Multi-Select
var serviceCheckboxes = document.querySelectorAll('.contact-service-checkbox');
var servicesHidden = document.getElementById('contact-services-hidden');
if (serviceCheckboxes.length && servicesHidden) {
  function updateServicesHidden() {
    var values = [];
    serviceCheckboxes.forEach(function (cb) {
      if (cb.checked) values.push(cb.dataset.value);
    });
    servicesHidden.value = values.join(', ');
  }
  serviceCheckboxes.forEach(function (cb) {
    cb.addEventListener('change', updateServicesHidden);
  });
}
